module.exports = __webpack_public_path__ + "static/img/5.a492415.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/5.jpg
// module id = vGcb
// module chunks = 21